import { heHepTranslations } from './heHepTranslations';

export const heTranslations = {
  common: {
    cancel: 'ביטול',
    apply: 'החלה',
    reset: 'איפוס',
    save: 'שמירה',
  },
  copy_for_emr: {
    modal: {
      summary: 'סיכום',
      easyDocumentation: 'תיעוד מהיר',
      easyDocumentationDescription:
        'בעזרת התיעוד המהיר אפשר לחסוך זמן במילוי הרשומה הרפואית של המטופל.',
      summaryUnavailable: 'הסיכום אינו זמין',
      summaryUnavailableDescription:
        'לא הצלחנו לטעון את ניתוח הפעילות, ולכן הסיכום יהיה חלקי.\nכדאי לנסות שוב מאוחר יותר במקום להעתיק נתונים חלקיים לרשומה הרפואית.',
      cancel: 'ביטול',
      back: 'חזרה',
      copy: 'העתקה',
      copied: 'הועתק ללוח!',
    },
  },
  ...heHepTranslations,
};
